function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M52.3716 34.6843L35.6482 5.73512C33.776 2.33814 30.6727 0.167969 26.7291 0.167969C23.9009 0.167969 20.7976 2.33814 18.9249 5.73512L2.20152 34.6843C-0.334742 38.9082 -0.642398 42.7118 1.08663 45.8186C2.74292 48.64 5.06817 50.2724 10.0058 50.2724H43.4525C48.3896 50.2724 51.8295 48.64 53.4865 45.8186C55.2149 42.7118 54.9083 38.9093 52.3716 34.6843Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.1418 44.7048C49.564 46.2486 46.6833 46.9316 43.4525 46.9316H10.0057C6.7398 46.9316 5.00939 46.2486 4.4313 44.7048C2.87398 42.509 3.18079 39.9116 4.4313 36.9107L21.1547 7.96154C23.0789 5.07562 25.1507 3.50781 26.7291 3.50781C29.4227 3.50781 31.4945 5.07562 33.4184 7.96154L50.1418 36.9107C51.3915 39.9116 51.6994 42.509 50.1418 44.7048Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.7291 14.6406C26.362 14.6406 25.6143 15.4021 25.6143 16.8675V31.3421C25.6143 32.8075 26.362 33.5689 26.7291 33.5689C28.2101 33.5689 28.9589 32.8075 28.9589 31.3421V16.8675C28.9589 15.4021 28.2101 14.6406 26.7291 14.6406Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.7291 35.7969C26.362 35.7969 25.6143 36.5144 25.6143 36.9103V39.1372C25.6143 39.533 26.362 40.2506 26.7291 40.2506C28.2101 40.2506 28.9589 39.533 28.9589 39.1372V36.9103C28.9589 36.5144 28.2101 35.7969 26.7291 35.7969Z",
  fill: "currentColor",
  stroke: "currentColor"
});

var SvgIcModalWarn = function SvgIcModalWarn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcModalWarn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_modal_warn.35a8cc2f.svg";
export { ForwardRef as ReactComponent };